import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchProducts,
  SearchProductsVariables
} from "./types/SearchProducts";

export const searchProducts = gql`
  ${pageInfoFragment}
  query SearchProducts(
    $after: String
    $first: Int!
    $query: String!
    $brands: [ID]
    $productStatus: ProductStatusEnum
    $isPublished: Boolean
    $categories: [ID]
    $malls: [ID]
    $userViewInfo: ProductUserViewInfoInput
  ) {
    search: products(
      after: $after
      first: $first
      filter: {
        searchByName: $query
        brands: $brands
        productStatus: $productStatus
        isPublished: $isPublished
        categories: $categories
        malls: $malls
      }
      userViewInfo: $userViewInfo
    ) {
      edges {
        node {
          id
          name
          thumbnail {
            url
          }
          variants {
            id
            name
            price {
              currency
              amount
            }
            sku
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchProducts, SearchProductsVariables>(
  searchProducts
);
